// Add your JS customizations here
jQuery(document).ready(function($) {
    // Check if the current page is the /the-cars page
    if (window.location.pathname === '/the-cars/') {
        // Add class 'show' to the anchor tag and the dropdown menu ul for .cars-menu-item
        var $carsMenuItem = $('.cars-menu-item > a');
        var $dropdownMenu = $carsMenuItem.next('.dropdown-menu');

        $carsMenuItem.addClass('show');
        $dropdownMenu.addClass('show');
    } else if (window.location.pathname === '/de/autos/') {
        // Add class 'show' to the anchor tag and the dropdown menu ul for .autos-menu-item
        var $autosMenuItem = $('.autos-menu-item > a');
        var $dropdownMenu = $autosMenuItem.next('.dropdown-menu');

        $autosMenuItem.addClass('show');
        $dropdownMenu.addClass('show');
    } else {
        // If not on the /the-cars or /die-autos page, update the href attribute and remove data-toggle attributes
        var $carsMenuItem = $('.cars-menu-item > a');
        var $autosMenuItem = $('.autos-menu-item > a');

        $carsMenuItem.attr('href', '/the-cars').removeAttr('data-toggle').removeAttr('data-bs-toggle');
        $autosMenuItem.attr('href', '/de/autos').removeAttr('data-toggle').removeAttr('data-bs-toggle');
    }


    $(window).on("scroll", function(e) {
        if(window.scrollY > 172){
        $('.second-menu-wrap').addClass('scrolled');
        }
        else{
        $('.second-menu-wrap').removeClass('scrolled');
        }
    });
    $(window).scroll(function() {
        if ($(this).scrollTop() > 188) {
            $('.header-wrap').addClass('scrolled');
        } else {
            $('.header-wrap').removeClass('scrolled');
        }
    });

    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
    
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

    // document.getElementById('btnSwitch').addEventListener('click',()=>{
    //     if (document.documentElement.getAttribute('data-bs-theme') == 'dark') {
    //         document.documentElement.setAttribute('data-bs-theme','light')
    //     }
    //     else {
    //         document.documentElement.setAttribute('data-bs-theme','dark')
    //     }
    // })
    function formatCurrency(amount) {
        // Convert amount to a number
        var number = parseFloat(amount.replace(/[^0-9.-]+/g,""));
        // Format as currency (assuming USD)
        var formatted = "$" + number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return formatted;
    }
    $('.vc_gitem-post-meta-field-garage_price').each(function() {
        console.log("working");
        // Get the text content of the element
        var priceText = $(this).text();
        // Format the price
        var formattedPrice = formatCurrency(priceText);
        // Set the formatted text back to the element
        $(this).text(formattedPrice);
    });
    $(window).on('load', function() {
        $('.vc_gitem-post-meta-field-garage_price').each(function() {
        console.log("working");

            var priceText = $(this).text();
            // Remove $ sign and commas from the text
            var numericValue = parseFloat(priceText.replace(/[$,]/g, ''));
            // Format numeric value as currency
            var formattedPrice = '$' + numericValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            $(this).text(formattedPrice);
        });
    });

    // Initial update on document ready
    // updateLogoSrc();

    var logoImg = $('.navbar-brand img');

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value ? 'true' : 'false') + expires + "; path=/";
    }
    
    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    
    var darkModeEnabled = getCookie('darkModeEnabled') === 'true';
    var currentSource = logoImg.attr('src');
    if (darkModeEnabled) {
        $("body").addClass("dark");
        // Change icon to sun
        $("#darkModeButton i").removeClass("fa-moon").addClass("fa-sun");
        // Toggle logo image source
        
        var newSrc = currentSource.includes('-dark.svg') ? currentSource : currentSource.replace('.svg', '-dark.svg');
        logoImg.attr('src', newSrc);
    }
    
    $(".darkModeButton").click(function() {
        var isDarkMode = $("body").hasClass("dark");
        $("body").toggleClass("dark");
        $("#main-nav").toggleClass("navbar-dark");
        // Change icon based on dark mode state
        $(this).find("i").toggleClass("fa-moon fa-sun");
        // Toggle logo image source
        var currentSource = logoImg.attr('src');
        var newSrc = currentSource.includes('-dark.svg') ? currentSource.replace('-dark.svg', '.svg') : currentSource.replace('.svg', '-dark.svg');
        logoImg.attr('src', newSrc);
        // Set cookie to remember dark mode state
        setCookie('darkModeEnabled', !isDarkMode, 365); // Cookie valid for 365 days
    });


    

})